// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Timeframe Footer Styles - CSS Module — TradingView parity, WCAG AA */
.skrF9hhNMKwW4gdwqjgk {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 8px;
  background: var(--vnsc-bg-secondary, transparent);
  border-top: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  z-index: 30;
  /* Single line always: compact density fits the viewport; scrolls only when
     truly narrower than content (last resort, never wraps). */
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  font-family: var(--vnsc-font-family-base, "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--vnsc-text-secondary, #787b86);
}

._yKUfd0WhLykQXFIHHV7 {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

.nFl6qLP_pI_1ZpvHAjDN {
  padding: 2px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.nFl6qLP_pI_1ZpvHAjDN:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

.fJmyC0E13GHt5ryV7eob {
  /* V-05: solid + white = 5.2:1 (was translucent/accent, weak). */
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  font-weight: 600;
  border-color: var(--vnsc-accent-strong, #2563eb);
  box-shadow: none;
}

.fJmyC0E13GHt5ryV7eob:hover {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  border-color: var(--vnsc-accent-hover, #1e4bd8);
}

.Zfha8BJti_Jn1fknZ_12 {
  width: 1px;
  height: 14px;
  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));
}

.tTGUw3ivp2gk78vpiuLP {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

.Xi4HeVfF8FOqAUfz_Xir {
  padding: 2px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.Xi4HeVfF8FOqAUfz_Xir:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

.AvLGcwvcyw8KA4J_yqri {
  /* V-05: solid + white = 5.2:1 (was translucent/accent, weak). */
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  font-weight: 600;
  border-color: var(--vnsc-accent-strong, #2563eb);
  box-shadow: none;
}

.AvLGcwvcyw8KA4J_yqri:hover {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  border-color: var(--vnsc-accent-hover, #1e4bd8);
}

.GeJ3ujm3s2wWCC1W_pab {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* V-07: visible group captions (Interval vs Range) — ends 1D ambiguity. */
.mnaLZRR1VV8JzTQStTja {
  font-size: 10px;
  font-weight: 600;
  color: var(--vnsc-text-muted, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  align-self: center;
  margin-right: 2px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Compact: hide captions first when the viewport gets narrow — chips stay. */
@media (max-width: 1280px) {
  .mnaLZRR1VV8JzTQStTja {
    display: none;
  }
}

.GddXC_ujHnKoG1bIM1_E {
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.GeJ3ujm3s2wWCC1W_pab + .GddXC_ujHnKoG1bIM1_E {
  margin-left: 0;
}

.bD3ITS7H7eduduxMQ2RO {
  display: flex;
  gap: 2px;
  padding: 2px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  background: transparent;
}

.EcTqSTs0gCramHEHmYjO {
  padding: 2px 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
}

.EcTqSTs0gCramHEHmYjO:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

.Ro3r89SQOOl35lVVSfrf {
  /* V-05: solid #2563eb + white = 5.2:1. */
  background: var(--vnsc-accent-strong, #2563eb);
  color: var(--vnsc-text-on-primary, #ffffff);
  font-weight: 600;
}

.cyalFGMILfkg0SFvLiv8 {
  padding: 2px 6px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  color: var(--vnsc-text-secondary, #787b86);
  background: var(--vnsc-bg-hover, transparent);
  white-space: nowrap;
}

.U13vqDGgqnE7_P3pRrkv {
  font-size: 11px;
  font-weight: 500;
  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);
  color: var(--vnsc-text-primary, #d1d4dc);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.P6fxWVdTbuqAV2nqBhvB {
  font-variant-numeric: tabular-nums;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);
  color: var(--vnsc-accent, #2962ff);
  white-space: nowrap;
}

.Q71oRCCXYf7220aneayH {
  font-size: 10px;
  opacity: 0.7;
}

.GW1mofLT4qkJtF7gCD3m {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  color: var(--vnsc-text-muted, #6b7280);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  opacity: 0.9;
}

.GW1mofLT4qkJtF7gCD3m:hover {
  color: var(--vnsc-text-secondary, #787b86);
  opacity: 1;
}

.U_Qn1_tjinRPvepyvI97 {
  font-size: 11px;
  color: var(--vnsc-accent, #2962ff);
  opacity: 0.7;
}

.U_Qn1_tjinRPvepyvI97:hover {
  color: var(--vnsc-accent, #2962ff);
  opacity: 1;
}

@media (max-width: 480px) {
  .skrF9hhNMKwW4gdwqjgk {
    padding: 4px 8px;
    gap: 8px;
  }
  
  .nFl6qLP_pI_1ZpvHAjDN,
  .Xi4HeVfF8FOqAUfz_Xir {
    padding: 2px 6px;
    font-size: 10px;
  }
  
  .Zfha8BJti_Jn1fknZ_12 {
    height: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/timeframe-footer.module.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iDAAiD;EACjD,mEAAmE;EACnE,WAAW;EACX;8DAC4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qHAAqH;EACrH,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,wCAAwC;EACxC,qEAAqE;EACrE,2DAA2D;AAC7D;;AAEA;EACE,gEAAgE;EAChE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,wCAAwC;EACxC,qEAAqE;EACrE,2DAA2D;AAC7D;;AAEA;EACE,gEAAgE;EAChE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,+DAA+D;EAC/D,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,2DAA2D;AAC7D;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Timeframe Footer Styles - CSS Module — TradingView parity, WCAG AA */\r\n.timeframeFooter {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 3px 8px;\r\n  background: var(--vnsc-bg-secondary, transparent);\r\n  border-top: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  z-index: 30;\r\n  /* Single line always: compact density fits the viewport; scrolls only when\r\n     truly narrower than content (last resort, never wraps). */\r\n  flex-wrap: nowrap;\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n  font-family: var(--vnsc-font-family-base, \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.timeframeChips {\r\n  display: flex;\r\n  gap: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.tfChip {\r\n  padding: 2px 6px;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.tfChip:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.tfChipActive {\r\n  /* V-05: solid + white = 5.2:1 (was translucent/accent, weak). */\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: #fff;\r\n  font-weight: 600;\r\n  border-color: var(--vnsc-accent-strong, #2563eb);\r\n  box-shadow: none;\r\n}\r\n\r\n.tfChipActive:hover {\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: #fff;\r\n  border-color: var(--vnsc-accent-hover, #1e4bd8);\r\n}\r\n\r\n.separator {\r\n  width: 1px;\r\n  height: 14px;\r\n  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.rangeChips {\r\n  display: flex;\r\n  gap: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.rangeChip {\r\n  padding: 2px 6px;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.rangeChip:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.rangeChipActive {\r\n  /* V-05: solid + white = 5.2:1 (was translucent/accent, weak). */\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: #fff;\r\n  font-weight: 600;\r\n  border-color: var(--vnsc-accent-strong, #2563eb);\r\n  box-shadow: none;\r\n}\r\n\r\n.rangeChipActive:hover {\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: #fff;\r\n  border-color: var(--vnsc-accent-hover, #1e4bd8);\r\n}\r\n\r\n.footerChildren {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* V-07: visible group captions (Interval vs Range) — ends 1D ambiguity. */\r\n.groupCaption {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-muted, #6b7280);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  align-self: center;\r\n  margin-right: 2px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Compact: hide captions first when the viewport gets narrow — chips stay. */\r\n@media (max-width: 1280px) {\r\n  .groupCaption {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.rightCluster {\r\n  margin-left: auto;\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.footerChildren + .rightCluster {\r\n  margin-left: 0;\r\n}\r\n\r\n.scaleGroup {\r\n  display: flex;\r\n  gap: 2px;\r\n  padding: 2px;\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  background: transparent;\r\n}\r\n\r\n.scaleBtn {\r\n  padding: 2px 6px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.scaleBtn:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.scaleBtnActive {\r\n  /* V-05: solid #2563eb + white = 5.2:1. */\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: var(--vnsc-text-on-primary, #ffffff);\r\n  font-weight: 600;\r\n}\r\n\r\n.tzBadge {\r\n  padding: 2px 6px;\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  background: var(--vnsc-bg-hover, transparent);\r\n  white-space: nowrap;\r\n}\r\n\r\n.clockText {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n}\r\n\r\n.countdownText {\r\n  font-variant-numeric: tabular-nums;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);\r\n  color: var(--vnsc-accent, #2962ff);\r\n  white-space: nowrap;\r\n}\r\n\r\n.countdownGlyph {\r\n  font-size: 10px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.trademark {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 0 8px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  color: var(--vnsc-text-muted, #6b7280);\r\n  cursor: pointer;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n  opacity: 0.9;\r\n}\r\n\r\n.trademark:hover {\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  opacity: 1;\r\n}\r\n\r\n.trademarkIcon {\r\n  font-size: 11px;\r\n  color: var(--vnsc-accent, #2962ff);\r\n  opacity: 0.7;\r\n}\r\n\r\n.trademarkIcon:hover {\r\n  color: var(--vnsc-accent, #2962ff);\r\n  opacity: 1;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .timeframeFooter {\r\n    padding: 4px 8px;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .tfChip,\r\n  .rangeChip {\r\n    padding: 2px 6px;\r\n    font-size: 10px;\r\n  }\r\n  \r\n  .separator {\r\n    height: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeframeFooter": `skrF9hhNMKwW4gdwqjgk`,
	"timeframeChips": `_yKUfd0WhLykQXFIHHV7`,
	"tfChip": `nFl6qLP_pI_1ZpvHAjDN`,
	"tfChipActive": `fJmyC0E13GHt5ryV7eob`,
	"separator": `Zfha8BJti_Jn1fknZ_12`,
	"rangeChips": `tTGUw3ivp2gk78vpiuLP`,
	"rangeChip": `Xi4HeVfF8FOqAUfz_Xir`,
	"rangeChipActive": `AvLGcwvcyw8KA4J_yqri`,
	"footerChildren": `GeJ3ujm3s2wWCC1W_pab`,
	"groupCaption": `mnaLZRR1VV8JzTQStTja`,
	"rightCluster": `GddXC_ujHnKoG1bIM1_E`,
	"scaleGroup": `bD3ITS7H7eduduxMQ2RO`,
	"scaleBtn": `EcTqSTs0gCramHEHmYjO`,
	"scaleBtnActive": `Ro3r89SQOOl35lVVSfrf`,
	"tzBadge": `cyalFGMILfkg0SFvLiv8`,
	"clockText": `U13vqDGgqnE7_P3pRrkv`,
	"countdownText": `P6fxWVdTbuqAV2nqBhvB`,
	"countdownGlyph": `Q71oRCCXYf7220aneayH`,
	"trademark": `GW1mofLT4qkJtF7gCD3m`,
	"trademarkIcon": `U_Qn1_tjinRPvepyvI97`
};
export default ___CSS_LOADER_EXPORT___;
